const fmt = (dt) => dt.toISOString().slice(0, 10);

export function computeRange(preset, from, to) {
  const n = new Date();
  if (preset === "today") { const t = fmt(n); return { from: t, to: t }; }
  if (preset === "week") { const d = new Date(n); d.setDate(n.getDate() - 6); return { from: fmt(d), to: fmt(n) }; }
  if (preset === "month") return { from: fmt(new Date(n.getFullYear(), n.getMonth(), 1)), to: fmt(new Date(n.getFullYear(), n.getMonth() + 1, 0)) };
  if (preset === "lastmonth") return { from: fmt(new Date(n.getFullYear(), n.getMonth() - 1, 1)), to: fmt(new Date(n.getFullYear(), n.getMonth(), 0)) };
  if (preset === "custom") return { from: from || "", to: to || "" };
  return { from: "", to: "" };
}

export function inRange(dateStr, from, to) {
  if (!from && !to) return true;
  if (!dateStr) return false;
  const d = String(dateStr).slice(0, 10);
  if (from && d < from) return false;
  if (to && d > to) return false;
  return true;
}

// Dark-theme period filter — chip/pill style (no white panel).
export function PeriodFilter({ value, onChange }) {
  const presets = [["all", "All"], ["today", "Today"], ["week", "This Week"], ["month", "This Month"], ["lastmonth", "Last Month"], ["custom", "Custom"]];
  const dateCls = "h-9 rounded-lg border border-[#29466D] bg-[#102544] px-2 text-xs text-white outline-none [color-scheme:dark] focus:border-[#1684FF]";
  return (
    <div data-testid="period-filter" className="mt-3 flex flex-wrap items-center gap-1.5">
      {presets.map(([k, l]) => {
        const active = value.preset === k;
        return (
          <button
            key={k}
            data-testid={`period-${k}`}
            onClick={() => onChange({ ...value, preset: k })}
            className={`rounded-full border px-3 py-1 text-xs font-semibold transition-colors ${
              active
                ? "border-[#1684FF] bg-[#1684FF] text-white shadow-[0_0_12px_-2px_rgba(22,132,255,0.8)]"
                : "border-[#29466D] bg-[#102544] text-[#C3D0E2] hover:border-[#1684FF]/60 hover:text-white"
            }`}
          >
            {l}
          </button>
        );
      })}
      {value.preset === "custom" && (
        <div className="flex items-center gap-1.5">
          <input data-testid="period-from" type="date" value={value.from} onChange={(e) => onChange({ ...value, from: e.target.value })} className={dateCls} />
          <span className="text-xs text-[#7E91AC]">–</span>
          <input data-testid="period-to" type="date" value={value.to} onChange={(e) => onChange({ ...value, to: e.target.value })} className={dateCls} />
        </div>
      )}
      {value.preset !== "all" && (
        <button data-testid="period-reset" onClick={() => onChange({ preset: "all", from: "", to: "" })} className="rounded-full border border-[#29466D] px-3 py-1 text-xs font-semibold text-[#7E91AC] transition-colors hover:text-white">Reset</button>
      )}
    </div>
  );
}
